import React from "react";
import { DmsPage, DmsAltBox, intl } from "dmsbasereact";
import { Typography } from "@mui/material";
import { SAPCommunicationTable } from "./components/SAPCommunicationTable";

/**
 * SAPCommunicationPage Component
 * @component
 *
 * @description
 * Página de logs de comunicação com o SAP dentro do sistema Programa Lena.
 * Esta página permite aos usuários visualizar logs de comunicação entre o sistema e o SAP,
 * incluindo requisições enviadas, payloads, status e respostas.
 *
 * SAP Configuration is available in System > Settings.
 *
 * @returns {JSX.Element}
 * Uma página renderizando a tabela de comunicação SAP.
 */
export const SAPCommunicationPage = () => {
    return (
        <DmsPage name="SAP Communication Logs">
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant='h3' sx={{ fontSize: '1.1rem' }}>
                        {intl.get("SAPCommunicationLogs").d("SAP Communication Logs")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body>
                    <SAPCommunicationTable />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    );
};
